import arrowRightIcon from '@raison/static/icons/arrow-right-s-line.svg';
import cn from 'classnames';
import React from 'react';

const ListLayout = ({children, className}: {children?: React.ReactNode; className?: string}) => (
    <div className={cn(className, 'list-none divide-y divide-solid divide-neutral-30 px-4')}>{children}</div>
);
const __Arrow = () => <img alt='' width='20' height='20' src={arrowRightIcon} />;
__Arrow.displayName = 'ListLayout.Arrow';
ListLayout.Arrow = __Arrow;

export default ListLayout;
